import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-content">
        <h1 className="hero-title">Joe Rickard</h1>
        <div className="hero-tagline">
          <span className="tagline-item">build.</span>
          <span className="tagline-item">create.</span>
          <span className="tagline-item">play.</span>
        </div>
        <p className="hero-description">
          Developer by day, creator by night. I craft software that solves problems, games that spark joy, and music that moves souls.<br />Oh, and I'm really modest too.
        </p>
        <div className="hero-cta">
          <Link to="/software" className="cta-button primary">
            See What I Build
          </Link>
          <Link to="/contact" className="cta-button secondary">
            Let's Connect
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hero;
